import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import Users from "../pages/users/Users";
import AddUser from "../pages/users/AddUser";

import Faq from "../pages/faq/Faq";
import AddFaq from "../pages/faq/AddFaq";

import Order from "../pages/order/Order";

import Drivers from "../pages/drivers/Drivers";
import AddDriver from "../pages/drivers/AddDriver";

import DeliveryModes from "../pages/deliveryModes/DeliveryModes";
import AddDeliveryModes from "../pages/deliveryModes/AddDeliveryModes";

import Payments from "../pages/payment/Payment";
import AddPayment from "../pages/payment/AddPayment";

import Transaction from "../pages/transaction/Transaction";

import Supports from "../pages/support/Support";
import AddSupport from "../pages/support/AddSupport";

import PrivateRoute from "../routes/PrivateRoute";
import EditUser from "../pages/users/EditUser";
import UserProfile from "../pages/profile/UserProfile";
import UserPassword from "../pages/updatePassword/UserPassword";

import Login from "../pages/loginPage/Login";

export default function PageRoutes() {
  return (
    <Routes>
      {/* this login page is temp. right now  */}
      <Route path="/login" element={<Login />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }
      />
      <Route
        path="/users"
        element={
          <PrivateRoute>
            <Users />
          </PrivateRoute>
        }
      />
      <Route
        path="/adduser"
        element={
          <PrivateRoute>
            <AddUser />
          </PrivateRoute>
        }
      />
      <Route path="/edituser/:id" element={<EditUser />} />
      <Route
        path="/drivers"
        element={
          <PrivateRoute>
            <Drivers />
          </PrivateRoute>
        }
      />
      <Route
        path="/adddriver"
        element={
          <PrivateRoute>
            <AddDriver />
          </PrivateRoute>
        }
      />
      <Route
        path="/addfaq"
        element={
          <PrivateRoute>
            <AddFaq />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <PrivateRoute>
            <Order />
          </PrivateRoute>
        }
      />
      <Route
        path="/adddeliverymodes"
        element={
          <PrivateRoute>
            <AddDeliveryModes />
          </PrivateRoute>
        }
      />
      <Route
        path="/deliverymodes"
        element={
          <PrivateRoute>
            <DeliveryModes />
          </PrivateRoute>
        }
      />
      <Route
        path="/transactions"
        element={
          <PrivateRoute>
            <Transaction />
          </PrivateRoute>
        }
      />
      <Route
        path="/faq"
        element={
          <PrivateRoute>
            <Faq />
          </PrivateRoute>
        }
      />
      <Route
        path="/payments"
        element={
          <PrivateRoute>
            <Payments />
          </PrivateRoute>
        }
      />
      <Route
        path="/addpayments"
        element={
          <PrivateRoute>
            <AddPayment />
          </PrivateRoute>
        }
      />
      <Route
        path="/support"
        element={
          <PrivateRoute>
            <Supports />
          </PrivateRoute>
        }
      />
      <Route
        path="/addsupport"
        element={
          <PrivateRoute>
            <AddSupport />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <UserProfile />
          </PrivateRoute>
        }
      />
      <Route
        path="/account"
        element={
          <PrivateRoute>
            <UserPassword />
          </PrivateRoute>
        }
      />
      {/* <Route
                  path='*'
                  element={<Navigate to='/' replace></Navigate>}
                /> */}
    </Routes>
  );
}
